(() => {
  const name = 'campaignActivation';

  App.common = App.common || {};

  App.common[name] = (() => {
    let $renderedBlock = null;
    let $titleBlock = null;
    let title = null;
    let $activationBlock = null;
    let $errorBlock = null;

    const setEventListeners = () => {
      $('.campaign-popup__activation-cancel').on('click', (e) => {
        e.preventDefault();
        document.forms.campaign_activation_cancel.submit();
      });

      $('.campaign-popup__restriction-cancel').on('click', (e) => {
        e.preventDefault();
        document.forms.campaign_restriction_cancel.submit();
      });
    };

    const buildPopup = () => {
      $titleBlock = $renderedBlock.find('.campaign-popup__title');
      $errorBlock = $renderedBlock.find('.campaign-popup__error');
      title = ($titleBlock.length > 0) ? $titleBlock.text() : '';
      $titleBlock.remove();

      $renderedBlock.removeClass('hide');
      App.ui.popup($renderedBlock, {
        unclosable: true,
        className: 'campaign-popup-rendered',
        title: `<span>${title}</span>`,
      });
      if ($errorBlock.length) {
        App.global.sendErrorLog($errorBlock.text());
      }
    };

    const init = () => {
      $renderedBlock = $('.campaign-popup');
      $activationBlock = $('.campaign-popup__activation');
      if ($activationBlock.length > 0) {
        buildPopup();
        setEventListeners();
      }
    };

    return {
      init,
    };
  })();
})();
